export const ifElse = (condition: boolean) => (then: Function, or: Function) => (condition ? then() : or())
